ProductReviews = window.ProductReviews ?= {}
ProductReviews.Views ?= {}
ProductReviews.Templates ?= {}

ProductReviews.Templates['product_reviews_review_card'] = require '../../review_card.html.mustache'

ProductReviews.Views.ReviewCard = Backbone.View.extend
  render: ->
    data = _.extend {}, @model.attributes,
      displayOptions: @model.displayOptions
      translate: -> (text) -> I18n.t "js.#{text}"

    @$el.append ProductReviews.Templates['product_reviews_review_card'].render(data)


module.exports = ProductReviews.Views.ReviewCard
